import React, { useEffect, useState } from 'react';
import { Button, InputX, InputRed, LayerBottom } from 'components'
import useApp from 'hooks/useApp'

const MyCarEnter = () => {

	const App = useApp()
	const [confirmLayer, setConfirmLayer] = useState(false)

	const closeConfirm = () => {
		setConfirmLayer(false)
	}

	const showConfirm = () => {
		setConfirmLayer(true)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>차량번호를 입력하세요.</h3>
				<p className="guide-title mt_20">본인 소유의 차량만 등록 가능하며, 법인 및 명의가 다른<br />차량은 등록되지 않아요!</p>

				<p className="guide-title mt_40">주민등록번호</p>
				<InputX type="text" id="" placeholder="ex.123가1234" />

				<InputRed text="올바른 차량번호 형식이 아니에요." show={true} />
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={showConfirm}>다음</Button>
			</div>

			<ConfirmLayer show={confirmLayer} closeConfirm={closeConfirm} closeButton={false} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeConfirm }) => {
	const [errorOpen, setErrorOpen] = useState(false)

	const OpenError = () => {
		setErrorOpen(!errorOpen)
	}
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeConfirm} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeConfirm()}>확인</Button>
		}>
			<div className="layer-text py_10">
				<p style={{ fontSize: "1.6rem", fontWeight: 500 }}>본인 차량만 조회할 수 있어요.<br />본인 소유 차량의 차량번호로 다시 조회해주세요.</p>
				<div className={`error-code mt_20 ${errorOpen ? "active" : ""}`} onClick={OpenError}>
					<span className="flex-align_center text-red"><span>오류코드 100052</span><i className="icon icon_error_arrow ml_10" /></span>
					<div className="mt_10">조회된 차량 없음</div>
				</div>
			</div>
		</LayerBottom>
	)
}

export default MyCarEnter